//reducer
import {
  APPOINTMENT_LIST_REQUEST,
  APPOINTMENT_LIST_SUCCESS,
  APPOINTMENT_LIST_FAIL,
  APPOINTMENT_DATA_REQUEST,
  APPOINTMENT_DATA_SUCCESS,
  APPOINTMENT_DATA_FAIL,
  APPOINTMENT_CREATE_REQUEST,
  APPOINTMENT_CREATE_SUCCESS,
  APPOINTMENT_CREATE_FAIL,
  APPOINTMENT_UPDATE_REQUEST,
  APPOINTMENT_UPDATE_SUCCESS,
  APPOINTMENT_UPDATE_FAIL,
  APPOINTMENT_DELETE_REQUEST,
  APPOINTMENT_DELETE_SUCCESS,
  APPOINTMENT_DELETE_FAIL,
  APPOINTMENT_SEARCH_REQUEST,
  APPOINTMENT_SEARCH_SUCCESS,
  APPOINTMENT_SEARCH_FAIL,
  APPOINTMENT_TYPE_LIST_REQUEST,
  APPOINTMENT_TYPE_LIST_SUCCESS,
  APPOINTMENT_TYPE_LIST_FAIL,
  APPOINTMENT_TYPE_DATA_REQUEST,
  APPOINTMENT_TYPE_DATA_SUCCESS,
  APPOINTMENT_TYPE_DATA_FAIL,
  APPOINTMENT_TYPE_CREATE_REQUEST,
  APPOINTMENT_TYPE_CREATE_SUCCESS,
  APPOINTMENT_TYPE_CREATE_FAIL,
  APPOINTMENT_TYPE_UPDATE_REQUEST,
  APPOINTMENT_TYPE_UPDATE_SUCCESS,
  APPOINTMENT_TYPE_UPDATE_FAIL,
  APPOINTMENT_TYPE_DELETE_REQUEST,
  APPOINTMENT_TYPE_DELETE_SUCCESS,
  APPOINTMENT_TYPE_DELETE_FAIL,
  APPOINTMENT_STATUS_LIST_REQUEST,
  APPOINTMENT_STATUS_LIST_SUCCESS,
  APPOINTMENT_STATUS_LIST_FAIL,
  APPOINTMENT_STATUS_DATA_REQUEST,
  APPOINTMENT_STATUS_DATA_SUCCESS,
  APPOINTMENT_STATUS_DATA_FAIL,
  APPOINTMENT_STATUS_CREATE_REQUEST,
  APPOINTMENT_STATUS_CREATE_SUCCESS,
  APPOINTMENT_STATUS_CREATE_FAIL,
  APPOINTMENT_STATUS_UPDATE_REQUEST,
  APPOINTMENT_STATUS_UPDATE_SUCCESS,
  APPOINTMENT_STATUS_UPDATE_FAIL,
  APPOINTMENT_STATUS_DELETE_REQUEST,
  APPOINTMENT_STATUS_DELETE_SUCCESS,
  APPOINTMENT_STATUS_DELETE_FAIL,
  APPOINTMENT_SEARCH_SPECIFIC_LIST_REQUEST,
  APPOINTMENT_SEARCH_SPECIFIC_LIST_SUCCESS,
  APPOINTMENT_SEARCH_SPECIFIC_LIST_FAIL,
} from "./actionType";

const initialState = {
  appointmentList: [],
  appointmentListLoading: false,
  appointmentListError: null,

  appointmentData: [],
  appointmentDataLoading: false,
  appointmentDataError: null,

  appointmentCreate: [],
  appointmentCreateLoading: false,
  appointmentCreateError: null,

  appointmentUpdate: [],
  appointmentUpdateLoading: false,
  appointmentUpdateError: null,

  appointmentDelete: [],
  appointmentDeleteLoading: false,
  appointmentDeleteError: null,

  appointmentSearch: [],
  appointmentSearchLoading: false,
  appointmentSearchError: null,

  appointmentTypeList: [],
  appointmentTypeListLoading: false,
  appointmentTypeListError: null,

  appointmentTypeData: [],
  appointmentTypeDataLoading: false,
  appointmentTypeDataError: null,

  appointmentTypeCreate: [],
  appointmentTypeCreateLoading: false,
  appointmentTypeCreateError: null,

  appointmentTypeUpdate: [],
  appointmentTypeUpdateLoading: false,
  appointmentTypeUpdateError: null,

  appointmentTypeDelete: [],
  appointmentTypeDeleteLoading: false,
  appointmentTypeDeleteError: null,

  appointmentStatusList: [],
  appointmentStatusListLoading: false,
  appointmentStatusListError: null,

  appointmentStatusData: [],
  appointmentStatusDataLoading: false,
  appointmentStatusDataError: null,

  appointmentStatusCreate: [],
  appointmentStatusCreateLoading: false,
  appointmentStatusCreateError: null,

  appointmentStatusUpdate: [],
  appointmentStatusUpdateLoading: false,
  appointmentStatusUpdateError: null,

  appointmentStatusDelete: [],
  appointmentStatusDeleteLoading: false,
  appointmentStatusDeleteError: null,

  appointmentSearchSpecificList: [],
  appointmentSearchSpecificListLoading: false,
  appointmentSearchSpecificListError: null,
};

// reducer function
const Appointment = (state = initialState, action) => {
  switch (action.type) {
    case APPOINTMENT_LIST_REQUEST:
      return {
        ...state,
        appointmentListLoading: true,
        appointmentListError: null,
      };
    case APPOINTMENT_LIST_SUCCESS:
      return {
        ...state,
        appointmentList: action.payload,
        appointmentListLoading: false,
      };
    case APPOINTMENT_LIST_FAIL:
      return {
        ...state,
        appointmentListError: action.payload,
        appointmentListLoading: false,
      };

    case APPOINTMENT_DATA_REQUEST:
      return {
        ...state,
        appointmentDataLoading: true,
        appointmentDataError: null,
      };
    case APPOINTMENT_DATA_SUCCESS:
      return {
        ...state,
        appointmentData: action.payload,
        appointmentDataLoading: false,
      };
    case APPOINTMENT_DATA_FAIL:
      return {
        ...state,
        appointmentDataError: action.payload,
        appointmentDataLoading: false,
      };

    case APPOINTMENT_CREATE_REQUEST:
      return {
        ...state,
        appointmentCreateLoading: true,
        appointmentCreateError: null,
      };
    case APPOINTMENT_CREATE_SUCCESS:
      return {
        ...state,
        appointmentCreate: action.payload,
        appointmentCreateLoading: false,
      };
    case APPOINTMENT_CREATE_FAIL:
      return {
        ...state,
        appointmentCreateError: action.payload,
        appointmentCreateLoading: false,
      };

    case APPOINTMENT_UPDATE_REQUEST:
      return {
        ...state,
        appointmentUpdateLoading: true,
        appointmentUpdateError: null,
      };
    case APPOINTMENT_UPDATE_SUCCESS:
      return {
        ...state,
        appointmentUpdate: action.payload,
        appointmentUpdateLoading: false,
      };
    case APPOINTMENT_UPDATE_FAIL:
      return {
        ...state,
        appointmentUpdateError: action.payload,
        appointmentUpdateLoading: false,
      };

    case APPOINTMENT_DELETE_REQUEST:
      return {
        ...state,
        appointmentDeleteLoading: true,
        appointmentDeleteError: null,
      };
    case APPOINTMENT_DELETE_SUCCESS:
      return {
        ...state,
        appointmentDelete: action.payload,
        appointmentDeleteLoading: false,
      };
    case APPOINTMENT_DELETE_FAIL:
      return {
        ...state,
        appointmentDeleteError: action.payload,
        appointmentDeleteLoading: false,
      };

    case APPOINTMENT_SEARCH_REQUEST:
      return {
        ...state,
        appointmentSearchLoading: true,
        appointmentSearchError: null,
      };
    case APPOINTMENT_SEARCH_SUCCESS:
      return {
        ...state,
        appointmentSearch: action.payload,
        appointmentSearchLoading: false,
      };
    case APPOINTMENT_SEARCH_FAIL:
      return {
        ...state,
        appointmentSearchError: action.payload,
        appointmentSearchLoading: false,
      };

    case APPOINTMENT_TYPE_LIST_REQUEST:
      return {
        ...state,
        appointmentTypeListLoading: true,
        appointmentTypeListError: null,
      };
    case APPOINTMENT_TYPE_LIST_SUCCESS:
      return {
        ...state,
        appointmentTypeList: action.payload,
        appointmentTypeListLoading: false,
      };
    case APPOINTMENT_TYPE_LIST_FAIL:
      return {
        ...state,
        appointmentTypeListError: action.payload,
        appointmentTypeListLoading: false,
      };

    case APPOINTMENT_TYPE_DATA_REQUEST:
      return {
        ...state,
        appointmentTypeDataLoading: true,
        appointmentTypeDataError: null,
      };
    case APPOINTMENT_TYPE_DATA_SUCCESS:
      return {
        ...state,
        appointmentTypeData: action.payload,
        appointmentTypeDataLoading: false,
      };
    case APPOINTMENT_TYPE_DATA_FAIL:
      return {
        ...state,
        appointmentTypeDataError: action.payload,
        appointmentTypeDataLoading: false,
      };

    case APPOINTMENT_TYPE_CREATE_REQUEST:
      return {
        ...state,
        appointmentTypeCreateLoading: true,
        appointmentTypeCreateError: null,
      };
    case APPOINTMENT_TYPE_CREATE_SUCCESS:
      return {
        ...state,
        appointmentTypeCreate: action.payload,
        appointmentTypeCreateLoading: false,
      };
    case APPOINTMENT_TYPE_CREATE_FAIL:
      return {
        ...state,
        appointmentTypeCreateError: action.payload,
        appointmentTypeCreateLoading: false,
      };

    case APPOINTMENT_TYPE_UPDATE_REQUEST:
      return {
        ...state,
        appointmentTypeUpdateLoading: true,
        appointmentTypeUpdateError: null,
      };
    case APPOINTMENT_TYPE_UPDATE_SUCCESS:
      return {
        ...state,
        appointmentTypeUpdate: action.payload,
        appointmentTypeUpdateLoading: false,
      };
    case APPOINTMENT_TYPE_UPDATE_FAIL:
      return {
        ...state,
        appointmentTypeUpdateError: action.payload,
        appointmentTypeUpdateLoading: false,
      };

    case APPOINTMENT_TYPE_DELETE_REQUEST:
      return {
        ...state,
        appointmentTypeDeleteLoading: true,
        appointmentTypeDeleteError: null,
      };
    case APPOINTMENT_TYPE_DELETE_SUCCESS:
      return {
        ...state,
        appointmentTypeDelete: action.payload,
        appointmentTypeDeleteLoading: false,
      };
    case APPOINTMENT_TYPE_DELETE_FAIL:
      return {
        ...state,
        appointmentTypeDeleteError: action.payload,
        appointmentTypeDeleteLoading: false,
      };

    case APPOINTMENT_STATUS_LIST_REQUEST:
      return {
        ...state,
        appointmentStatusListLoading: true,
        appointmentStatusListError: null,
      };
    case APPOINTMENT_STATUS_LIST_SUCCESS:
      return {
        ...state,
        appointmentStatusList: action.payload,
        appointmentStatusListLoading: false,
      };
    case APPOINTMENT_STATUS_LIST_FAIL:
      return {
        ...state,
        appointmentStatusListError: action.payload,
        appointmentStatusListLoading: false,
      };

    case APPOINTMENT_STATUS_DATA_REQUEST:
      return {
        ...state,
        appointmentStatusDataLoading: true,
        appointmentStatusDataError: null,
      };
    case APPOINTMENT_STATUS_DATA_SUCCESS:
      return {
        ...state,
        appointmentStatusData: action.payload,
        appointmentStatusDataLoading: false,
      };
    case APPOINTMENT_STATUS_DATA_FAIL:
      return {
        ...state,
        appointmentStatusDataError: action.payload,
        appointmentStatusDataLoading: false,
      };

    case APPOINTMENT_STATUS_CREATE_REQUEST:
      return {
        ...state,
        appointmentStatusCreateLoading: true,
        appointmentStatusCreateError: null,
      };
    case APPOINTMENT_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        appointmentStatusCreate: action.payload,
        appointmentStatusCreateLoading: false,
      };
    case APPOINTMENT_STATUS_CREATE_FAIL:
      return {
        ...state,
        appointmentStatusCreateError: action.payload,
        appointmentStatusCreateLoading: false,
      };

    case APPOINTMENT_STATUS_UPDATE_REQUEST:
      return {
        ...state,
        appointmentStatusUpdateLoading: true,
        appointmentStatusUpdateError: null,
      };
    case APPOINTMENT_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        appointmentStatusUpdate: action.payload,
        appointmentStatusUpdateLoading: false,
      };
    case APPOINTMENT_STATUS_UPDATE_FAIL:
      return {
        ...state,
        appointmentStatusUpdateError: action.payload,
        appointmentStatusUpdateLoading: false,
      };

    case APPOINTMENT_STATUS_DELETE_REQUEST:
      return {
        ...state,
        appointmentStatusDeleteLoading: true,
        appointmentStatusDeleteError: null,
      };
    case APPOINTMENT_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        appointmentStatusDelete: action.payload,
        appointmentStatusDeleteLoading: false,
      };
    case APPOINTMENT_STATUS_DELETE_FAIL:
      return {
        ...state,
        appointmentStatusDeleteError: action.payload,
        appointmentStatusDeleteLoading: false,
      };

    case APPOINTMENT_SEARCH_SPECIFIC_LIST_REQUEST:
      return {
        ...state,
        appointmentSearchSpecificListLoading: true,
        appointmentSearchSpecificListError: null,
      };
    case APPOINTMENT_SEARCH_SPECIFIC_LIST_SUCCESS:
      return {
        ...state,
        appointmentSearchSpecificList: action.payload,
        appointmentSearchSpecificListLoading: false,
      };
    case APPOINTMENT_SEARCH_SPECIFIC_LIST_FAIL:
      return {
        ...state,
        appointmentSearchSpecificListError: action.payload,
        appointmentSearchSpecificListLoading: false,
      };

    default:
      return state;
  }
};

export default Appointment;
